import { breakpointToDevice } from './breakpoints';

export default function csidBuilder({ csidParam, breakpoint, country, routeParams, sportParam, competitionParam, mediaName, partner }) {
  if (!breakpoint || !country) {
    throw new Error('breakpoint and country parameters required');
  }

  let device = breakpointToDevice(breakpoint);
  if (device === 'tabletPortrait' || device === 'tabletLandscape') device = 'tablet';

  let csid = `${device}.viasport.${country}`;

  if (partner) {
    csid += `/embed/${partner}`;
  } else if (csidParam === 'blogs' || csidParam === 'pods' || csidParam === 'tv-guide' || csidParam === 'premium') {
    csid += `/${csidParam}`;
    if (mediaName) csid += `/${mediaName}`;
    else if (csidParam === 'blogs' || csidParam === 'pods') csid += '/frontpage';
  } else {
    if (sportParam && competitionParam) {
      return `${csid}/${sportParam}/${competitionParam}`;
    } else if (!sportParam && !routeParams) {
      return csid;
    }

    if (sportParam) {
      csid += `/${sportParam}`;
    }

    if (routeParams && routeParams.competitions) {
      csid += `/${routeParams.competitions}`;
    } else if (!routeParams || !routeParams.teams) {
      if (csidParam) {
        csid += `/${csidParam}`;
      }
    }
  }

  return csid;
}



// WEBPACK FOOTER //
// ./src/util/csidBuilder.js